export default __webpack_public_path__ + "static/media/6.449fff51.jpg";